if (!customElements.get('play-video')) {
  class PlayVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        document.querySelector(`#${this.getAttribute('video')} video`)?.play();
      })
    }
  }
  customElements.define('play-video', PlayVideo);
}
